var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('md-button',{attrs:{"loading":_vm.loading1},on:{"click":_vm.clickButton1}},[_vm._v("按钮1")]),_c('md-button',{attrs:{"loading":_vm.loading2},on:{"click":_vm.clickButton2}},[_vm._v("按钮2")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }